module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "userInfo"
  }, [_c('mu-flexbox', {
    attrs: {
      "align": "flex-start"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "flex-demo"
  }, [_c('mu-flexbox', {
    staticStyle: {
      "margin-left": "40px"
    },
    attrs: {
      "orient": "vertical"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "flex-demo"
  }, [_c('ul', [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("订单号")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.order.id))])])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "flex-demo"
  }, [_c('ul', [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("订单状态")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v("\n              " + _vm._s(_vm.pay) + "\n              "), (_vm.showOrder) ? _c('a', {
    staticClass: "cancelOrderClass",
    on: {
      "click": _vm.open
    }
  }, [_vm._v("取消订单")]) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.showCancel,
      "dialogClass": "cancelOrderDialog"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "cancelOrderContent"
  }, [_vm._v("是否取消订单?")]), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "defaultBtn",
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": _vm.close
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "confirmBtn",
    staticStyle: {
      "color": "#999"
    },
    attrs: {
      "slot": "actions",
      "label": "是"
    },
    on: {
      "click": _vm.cancelOrder
    },
    slot: "actions"
  })], 1)], 1)])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "flex-demo"
  }, [_c('ul', [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("主治医生")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.store.account.name))])]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("开单人员")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.order.add_user_name))])])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "flex-demo"
  }, [_c('ul', [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("所属机构")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.order.org_name))])])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "flex-demo"
  }, [_c('ul', [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("患者姓名")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.order.user_name))])])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "flex-demo"
  }, [_c('ul', [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("订单金额")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v("￥" + _vm._s(_vm.order.order_total_fee))])])]), _vm._v(" "), (_vm.order.order_status == 'PAID' || _vm.order.order_status == 'END_OF_ORDER_USE') ? _c('mu-flexbox-item', {
    staticClass: "flex-demo"
  }, [_c('ul', [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.order.order_pay_mode == 'WX_PAY' ? '微信' : '支付宝'))])])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('mu-flexbox-item', [_c('mu-flexbox', {
    staticStyle: {
      "margin-left": "60px"
    },
    attrs: {
      "orient": "vertical"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "flex-demo"
  }, [_c('ul', [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("开单时间")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm._f("dateFormat")(_vm.order.add_time)))])])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "flex-demo"
  }, [_c('ul', [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("康复开始时间")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm._f("dateFormat")(_vm.order.order_use_start_time)))])])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "flex-demo"
  }, [_c('ul', [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("开单天数")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle",
    staticStyle: {
      "width": "200px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.order.order_days) + "天")])])])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "flex-demo"
  }, [_c('ul', [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("患者账号")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.order.user_mobile))])])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "flex-demo"
  }, [_c('ul', [(_vm.pay == '已取消') ? _c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("取消时间")]) : _vm._e(), _vm._v(" "), (_vm.pay == '已付款' || _vm.pay == '已完成') ? _c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("支付状态")]) : _vm._e(), _vm._v(" "), (_vm.pay == '已取消') ? _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm._f("dateFormat")(_vm.order.modify_time)))]) : _vm._e(), _vm._v(" "), (_vm.pay == '已付款' || _vm.pay == '已完成') ? _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v("支付成功   \n            ")]) : _vm._e(), (_vm.pay == '待支付') ? _c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("支付状态")]) : _vm._e(), _vm._v(" "), (_vm.pay == '待支付') ? _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.pay) + "   \n              "), (_vm.order.order_status == 'UNPAID') ? _c('span', {
    staticClass: "cancelOrderClass",
    on: {
      "click": _vm.openPay
    }
  }, [_vm._v("去支付")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.order.order_status == 'PAID' || _vm.order.order_status == 'END_OF_ORDER_USE') ? _c('mu-flexbox-item', {
    staticClass: "flex-demo"
  }, [_c('ul', [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("支付时间")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm._f("dateFormat")(_vm.order.order_pay_time)))])])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('mu-flexbox-item')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05251490!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/order/orderInfo.vue
// module id = 939
// module chunks = 2